import Hero from "@/sections/home/Hero";
import Statement from "@/sections/home/Statement";
import Services from "@/sections/home/Services";
import WhyUs from "@/sections/home/WhyUs";
import Approach from "@/sections/home/Approach";
import Frameworks from "@/sections/home/Frameworks";
import Industries from "@/sections/home/Industries";
import AssessCta from "@/sections/home/AssessCta";
import Investment from "@/sections/home/Investment";
import InsightsBand from "@/sections/home/InsightsBand";
import AboutBand from "@/sections/home/AboutBand";
import CtaBand from "@/components/CtaBand";
import { usePageMeta } from "@/lib/api";

export default function HomePage() {
  usePageMeta(
    "SarvaRitam | ESG & Sustainability Consulting",
    "SarvaRitam provides ESG and sustainability consulting across ESG strategy, BRSR, GHG accounting, climate risk, biodiversity, social impact, ESG policies, responsible investment and sustainability training."
  );
  return (
    <>
      <Hero />
      <Statement />
      <Services />
      <WhyUs />
      <Approach />
      <Frameworks />
      <Industries />
      <AssessCta />
      <Investment />
      <InsightsBand />
      <AboutBand />
      <CtaBand />
    </>
  );
}
